import { createReducer, on } from '@ngrx/store';
import { ManageCartsActions } from '../actions';
import { CreateNewCartState } from '../../../../SGRE-shared/store/shared-store/shared.state';

export const initialState: CreateNewCartState = {
  loading: null,
  success: null,
  error: null
};

const _createCartReducer = createReducer(
  initialState,
  on(ManageCartsActions.createCartSuccess, (state: CreateNewCartState, { success }): CreateNewCartState => ({
    ...state,
    loading: null,
    error: null,
    success,
  })),
  on(ManageCartsActions.createCartFailure, (state: CreateNewCartState, { error }): CreateNewCartState => ({
    ...state,
    loading: null,
    success: null,
    error
  })),
  on(ManageCartsActions.clearCreateCartState, (state: CreateNewCartState) => ({
    ...initialState
  }))
);

export function createCartReducer(state, action) {
  return _createCartReducer(state, action);
}